import React from 'react'
import whiteTick from '../../../assets/whiteTick.png'
import { plansData } from '../../../data/plansData'
// import {FormComponent} from '../FormComponent'
import './Plans.css'
import { Link } from 'react-router-dom'
// eslint-disable-next-line
const Plans = () => {
  return (
    <>
        {/* <FormComponent/> */}
      <div className="plans-container">
        <div className="blur plans-blur-1"></div>
        <div className="blur plans-blur-2"></div>
        <div 
            className="programs-header"
            style={{gap: '2rem'}}
        >
            <span className="stroke-text">READY TO START</span>
            <span>YOUR JOURNEY</span>
            <span className="stroke-text">NOW WITH US</span>   
        </div>
        <div className="plans">
            {plansData.map((plan, i) => (
                <div className="plan" key={i}>
                    {plan.icon}
                    <span>{plan.name}</span>
                    <span>$ {plan.price}</span>

                    <div className="features">
                    {plan.features.map((feature, index) => (
                        <div className="feature" key={index}>
                            <img src={whiteTick} alt="" />
                            <span>{feature}</span>
                        </div>
                    ))}
                    </div>
                    <div>
                        <span>See more benefits -> </span>
                    </div>    
                    
                    <Link to="/form"><button className="btn">Join now</button></Link>
                </div>  
            ))}
        </div>
    </div>
    </>
  )
}

export default Plans